'use client';

import MainNotificationBar from '@/app/(football)/[team]/_components/common/MainNotificationBar';
import { useTeamConfig } from '@/app/(football)/[team]/_context/context';
import { useMainPageConfig } from '@/app/(football)/[team]/main/_context/context';
import {
  useGetPointSaveWithInitQuery,
  useGetRepresentGalleryWithInitQuery,
  useGetTopItemsWithInitQuery,
  useGetTopNotificationWithInitQuery,
} from '@/store/server/common/football/football.query';

import AvailableMissionSection from './Section/AvailableMissionSection';
import CardGallerySection from './Section/CardGallerySection';
import HeroSection from './Section/HeroSection';
import TopCollectorSection from './Section/TopCollectorSection';
import TopItemSection from './Section/TopItemSection';

export default function MainContainer() {
  const { originalsName, teamSlug } = useTeamConfig();
  const { notificationRoutes } = useMainPageConfig();
  const { data: notificationData } = useGetTopNotificationWithInitQuery({ originalsName });
  const { data: pointSaveData } = useGetPointSaveWithInitQuery({ originalsName });
  const {
    data: topItemsData,
    isLoading: isTopItemsLoading,
    isError: isTopItemsError,
  } = useGetTopItemsWithInitQuery({ originalsName });
  const {
    data: galleryData,
    isLoading: isGalleryLoading,
    isError: isGalleryError,
  } = useGetRepresentGalleryWithInitQuery({ originalsName });

  return (
    <div className="flex flex-col items-center">
      {/* Top Notification Banner */}
      <MainNotificationBar notificationData={notificationData} notificationRoutes={notificationRoutes} />
      <div className="flex w-full flex-col items-center bg-bg-main pb-football-main-page-bottom" style={{
        backgroundImage: `url('https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/main/bg.webp')`,
        backgroundSize: '480px auto',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
      }}>

        {/* Hero Section */}
        <HeroSection />

        {/* Top Item Section */}
        <TopItemSection topItems={topItemsData} isLoading={isTopItemsLoading} isError={isTopItemsError} />

        {/* Available Missions Section */}
        <AvailableMissionSection missionList={pointSaveData?.rows} />

        {/* Top Collector Benefits Section */}
        <TopCollectorSection />

        {/* Card Gallery Section */}
        {(isGalleryLoading || (galleryData && galleryData.length > 0)) && (
          <CardGallerySection galleryData={galleryData ?? []} isLoading={isGalleryLoading} isError={isGalleryError} />
        )}
      </div>
    </div>
  );
}
